import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-block-retract",
  "use": "icon-block-retract-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-block-retract\">\n<style type=\"text/css\">\n\t#icon-block-retract .st0{fill:#EEEEEE;}\n\t#icon-block-retract .st1{fill:#666666;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M14,15H2c-0.6,0-1-0.5-1-1V2c0-0.6,0.5-1,1-1H14c0.6,0,1,0.5,1,1V14C15,14.5,14.5,15,14,15z\" />\n\t<g>\n\t\t<path class=\"st1\" d=\"M4.8,7.6h7.1v0.7H4.8V7.6z\" />\n\t</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol